import { route as notificationsPage } from "@faire/web-api--source/routes/www/user/notifications";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

export const useIsOnNotificationsPage = () => {
  const { pathname } = useLocation();
  return pathMatchesRoute(pathname, notificationsPage);
};
